<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-04 09:21:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-08-16 17:15:02
 * @Description: 鲸鱼优选 Banner
 -->

<template>
  <div class="banner-wrapper">
    <div class="content">
      <img src="https://files.jinr.com/jinr-index/img/m-jinr-banner.png" alt="" srcset="" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'm-banner'
};
</script>
<style lang="less" scoped>
.banner-wrapper {
  position: relative;
  overflow: hidden;
  .content {
    width: 100%;
    // height: 3.26rem;
    margin: 0 auto;
    // transform: translateX(1.3rem);
    position: relative;
  }
  img {
    display: block;
    width: 100%;
    // height: 100%;
    // position: absolute;
    // top: 0;
    // left: 50%;
    // transform: translateX(-50%);
  }
}
</style>
